const { REACT_APP_BASE_URL_API, REACT_APP_ITEMS_LIMIT } = process.env;

const constants = {
  baseURL: REACT_APP_BASE_URL_API,
  itemLimit: REACT_APP_ITEMS_LIMIT
};

export default constants;
